import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-dialog-header',
  templateUrl: './dialog-header.component.html',
  styleUrls: ['./dialog-header.component.scss'],
})
export class DialogHeaderComponent {
  @Input() public title!: string;
  @Input() public hideCloseButton: boolean = false;
}
